import React from "react";
import { useState } from "react";
import { availableKeywords } from "../pages/variables";

// CSS file for this component
import "../styles/ComparisonSearchBox.css";

function ComparisonSearchBox({ id, selectCountry }) {
  const boxId = `input-box-${id}`;

  // State for controlling input value
  const [inputValue, setInputValue] = useState("");

  // Placeholder state for search results or data
  const [results, setResults] = useState([]);

  // Tracks if the input field is focused (for UX purposes)
  const [inputFocused, setInputFocused] = useState(false);

  // Handles the input change event in the search box
  const handleInputChange = (e) => {
    const input = e.target.value;
    setInputValue(input);

    // Filter available countries
    const filtered = availableKeywords.filter((keyword) =>
      keyword.toLowerCase().startsWith(input.toLowerCase()),
    );

    setResults(filtered);
  };

  // Handles the action when a country is selected from the list
  const selectInput = (selectedCountry) => {
    if (availableKeywords.includes(selectedCountry)) {
      // Update input state
      setInputValue(selectedCountry);

      // Clear results dropdown
      setResults([]);

      // Send selected country to parent
      selectCountry(selectedCountry);
    }
  };

  // Handles the focus event of the input field (when user clicks into it)
  const handleFocus = () => {
    setInputFocused(true);

    // Show all available countries when focused
    setResults(availableKeywords);
  };

  // Handles the blur event of the input field (when user clicks outside)
  const handleBlur = () => {
    // Use a timeout to give the user time to click on an option before hiding the list
    setTimeout(() => {
      setInputFocused(false);
      setResults([]);
    }, 200);
  };

  // Handles the keydown event (for example, pressing Enter)
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (availableKeywords.includes(inputValue)) {
        selectInput(inputValue);
        e.target.blur();
      } else if (results.length === 1) {
        selectInput(results[0]);
        e.target.blur();
      }
    }
  };

  // Handles when the magnifying glass is clicked
  function handleMagniClick() {
    if (availableKeywords.includes(inputValue)) {
      selectInput(inputValue);
    }
  }

  // Handles when a country from the result box is clicked
  const handleResultClick = (countryName) => {
    // Updates input field with selected country
    selectInput(countryName);
  };

  return (
    <>
      <div className="comparison-search-box">
        {/* The input of the search-box */}
        <input
          id={boxId}
          type="text"
          placeholder="Search for a country..."
          autoComplete="off"
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
        />

        {/* The button for searching and setting the countryName */}
        <button className="magni-button" onClick={handleMagniClick}>
          <i className="fa-solid fa-magnifying-glass"></i>
        </button>

        {/* The result box for suggesting the countries */}
        <ResultBox results={results} handler={handleResultClick} />
      </div>
    </>
  );
}

function ResultBox({ results, handler }) {
  // Shows the country in the result box as list item
  function showResults(countryName, index) {
    return (
      <li
        key={index}
        // Handles the click on a countryName in the result box
        onMouseDown={() => {
          //puts onMouseDown instead of onClick to prevent blur event from hiding the list before the click is registered
          handler(countryName);
        }}
      >
        {/* Display country name */}
        {countryName}
      </li>
    );
  }

  return (
    <div className="search-result-box">
      {results.length > 0 && (
        <div className="search-result-scroll">
          <ul>{results.map(showResults)}</ul>
        </div>
      )}
    </div>
  );
}

export default ComparisonSearchBox;
